import * as STD                                                 from '@emersya/mpa-std-lib';
import CM                                                       from '@emersya/mpa-components-manager-lib';

export interface IMenuAccordionComponentConfiguration extends IMenuViewsComponentConfiguration {
};

export class MenuAccordionComponent extends MenuViewsComponent<
	MenuAccordionComponent,
	IMenuAccordionComponentConfiguration
>
{
	override async open(childId : string) {
		if (this.currentSection) {
			await this.close();
		}
		const child = <
			SectionComponent | undefined
			> this.component_findChild(childId);
		if (!child) {
			throw STD.errors.user('Child not found', {
				childId,
				component : this
			});
		}
		this.currentSection = child;
		child.component_DOM.classList.add('opened');
		await super.open(childId);
		await this.component_dispatchVisibilityUpdateOnChilds();
		await this.currentSection.component_dispatchVisibilityUpdateOnChilds();
		const childs = this.component_outerChilds.filter(
			x => x instanceof CM.DOMComponent
		) as CM.DOMComponent<any, any, any>[];
		for (const c of childs) {
			await c.component_dispatchVisibilityUpdateOnChilds();
		}
	};

	override async close() {
		if (!this.currentSection) {
			return;
		}
		await super.close();
		const oldSection = this.currentSection;
		this.currentSection = null;
		oldSection.component_DOM.classList.remove('opened');
		await this.component_dispatchVisibilityUpdateOnChilds();
		await oldSection.component_dispatchVisibilityUpdateOnChilds();
		const childs = this.component_outerChilds.filter(
			x => x instanceof CM.DOMComponent
		) as CM.DOMComponent<any, any, any>[];
		for (const c of childs) {
			await c.component_dispatchVisibilityUpdateOnChilds();
		}
	};

	private async onInputButton(ev : STD.events.Event<any, CM.Component<any, any>>) {
		if (!(ev.target instanceof CM.Component)) {
			throw STD.errors.user('');
		}
		const k : CM.Component.TAny | null = ev.target;
		if (!k) {
			throw STD.errors.user('');
		}
		if ((!k.component_parent) || (k.component_parent.component_parent !== this) || (k.id !== 'header')) {
			return;
		}
		const section = k.component_parent;
		if (this.currentSection !== section) {
			await this.open(section.id);
		} else {
			await this.close();
		}
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IMenuAccordionComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({});
		this.addEventListener('value', this.onInputButton.bind(this), {
			subType :                 'input-button',
			listener :                this,
			disableEventExistsCheck : true
		});
	};
};
export namespace NS {
	export const Component = MenuAccordionComponent;
	export type Component = MenuAccordionComponent;
	export type Configuration = IMenuAccordionComponentConfiguration;
}
;
import './MenuAccordion.scss';
import { MenuViewsComponent, IMenuViewsComponentConfiguration } from '../MenuViews/MenuViews';
import { SectionComponent }                                     from '../../Section/Section';

CM.declare({
	id :   'menu-accordion',
	type : MenuAccordionComponent
});
